import { ChakraText } from "components/ChakraText";
import { ErrorBoundary } from "components/ErrorBoundary/ErrorBoundary";
import { useGetQueue } from "../../../modules/queues/infrastructure/useGetQueue";

interface IProps {
  queueId: string;
  friendlyUrl: string;
}

const QueueBreadcrumbThrowable = ({ queueId, friendlyUrl }: IProps) => {
  const { data: queue } = useGetQueue(queueId, friendlyUrl);

  if (!queue) {
    return <></>;
  }

  return <ChakraText>{queue.name}</ChakraText>;
};

const QueueBreadcrumb = ({ ...props }: IProps) => {
  return (
    <ErrorBoundary fallback={() => <></>}>
      <QueueBreadcrumbThrowable {...props} />
    </ErrorBoundary>
  );
};

export { QueueBreadcrumb };
